module.exports = __webpack_public_path__ + "img/sauna-ja-laavu.ff7069dd.jpg";